// extracted by mini-css-extract-plugin
export default {"root":"classes_root__cweDT","resend-modal":"classes_resend-modal__qhwZI","description":"classes_description__jMq3u","button-container":"classes_button-container__hlh0R"};